export default "__VITE_ASSET__Wk7X6hsO__"